import { useEffect } from "react";

/**
 * Global scroll-reveal driver. Any element with [data-reveal] fades up when it
 * enters the viewport; stagger via style={{ "--reveal-i": n }} (80ms steps).
 * No-JS / prerender / reduced-motion → content stays fully visible.
 */
export default function ScrollRevealManager() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    document.documentElement.classList.add("js-reveal");

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("revealed");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: "0px 0px -36px 0px" },
    );

    const seen = new WeakSet();
    const scan = () => {
      document.querySelectorAll("[data-reveal]:not(.revealed)").forEach((el) => {
        if (!seen.has(el)) {
          seen.add(el);
          io.observe(el);
        }
      });
    };
    scan();
    const mo = new MutationObserver(scan);
    mo.observe(document.body, { childList: true, subtree: true });
    return () => {
      io.disconnect();
      mo.disconnect();
      document.documentElement.classList.remove("js-reveal");
    };
  }, []);
  return null;
}
